import React, { useState } from 'react'
import './index.scss'
import { Row, Col, Pagination, Input } from 'antd';
import { useEffect, useMemo } from 'react';
import Http from "@/utils/http";
import ConstValue from "@/utils/value";
import {
  LoadingOutlined, VideoCameraAddOutlined

} from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

export default function Search() {
  const [searchValue, setSearchValue] = useState('');
  const [searchV, setSearchV] = useState('');
  const [start, setstart] = useState(1);
  const [showHotSearch, setShowHotSearch] = useState(false);
  const [hotSearchTerms, setHotSearchTerms] = useState([]);

  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false);

  const [info, setinfo] = useState([]);
  const [infoOld, setinfoOld] = useState([]);
  const [infoNew, setNew] = useState([]);

  // 获取热搜词
  const getHotSearchTerms = async () => {
    try {
      let res = await Http.to.items('buzzword').readByQuery({
        fields: ['searchbuzzword']
      });
      
      if (res.data) {
        // 获取第一个buzzword项的searchbuzzword字段
        const searchBuzzword = res.data?.searchbuzzword;
        
        if (searchBuzzword) {
          // 按分号分割热搜词，并过滤空值
          const terms = searchBuzzword.split(';')
            .map(term => term.trim())
            .filter(term => term !== '');
          setHotSearchTerms(terms);
        } else {
          // 如果API没有返回数据，使用默认值
          setHotSearchTerms(['SFP', 'QSFP', '光纤模块', '以太网']);
        }
      } else {
        // 如果API没有返回数据，使用默认值
        setHotSearchTerms(['SFP', 'QSFP', '光纤模块', '以太网']);
      }
    } catch (error) {
      console.error('获取热搜词失败:', error);
      // 如果API调用失败，使用默认值
      setHotSearchTerms(['SFP', 'QSFP', '光纤模块', '以太网']);
    }
  }

  useEffect(() => {
    getHotSearchTerms();
  }, [])
  
  const getInfo = async () => {
    setIsLoading(true)
    setstart(1)
    setShowHotSearch(false);
    let res = await Http.to.items('Product_new').readByQuery({
      sort: ['id'],
      search: searchValue
    });
    setIsLoading(false)
    setinfo(res.data)
    getInfoOld()
    getNews()
  }
  
  const getNews = async () => {
    let res = await Http.to.items('New').readByQuery({
      sort: ['id'],
      filter: { status: "published" },
      search: searchValue
    });
    
    // 直接使用 API 返回的数据，保留原始 type 字段
    const newsData = res.data.map(item => ({
      ...item,
      displayName: item?.Title
    }));
    
    setNew(newsData)
  }
  
  const getInfoOld = async () => {
    setstart(1)
    if (searchValue === '') {
      setinfoOld([])
      return
    }
    setIsLoading(true)
    setSearchV(searchValue);
    let res = await Http.to.items('Pluggable_Transceiver').readByQuery({
      sort: ['id'],
      filter: { status: "published" },
      search: searchValue
    });
    let res2 = await Http.to.items('product_specifications').readByQuery({
      sort: ['id'],
      search: searchValue
    });
    let fildata = []
    res2.data.forEach(element => {
      fildata.push({ "_and": [{ "specification": { "id": { "_eq": element.id + '' } } }, { status: "published" }] })
    });

    let res3 = await Http.to.items('Pluggable_Transceiver').readByQuery({
      sort: ['id'],
      filter: { "_or": fildata }
    });

    let arr = [...res?.data, ...res3?.data];
    if (fildata.length === 0) {
      arr = res?.data;
    }
    let temp = {}
    arr.forEach(item => {
      temp[item.id] = item
    })
    setIsLoading(false)
    setinfoOld(Object.values(temp))
  }
  
  // 修改 toPage 函数，适应哈希路由
  const toPage = (address, id1, id2) => {
    console.log('跳转参数:', address, id1, id2);
    
    let url = '';
    
    if (address.indexOf('http') !== -1) {
      // 已经是完整的 URL
      url = address;
    } else if (id2) {
      // 有第二个 ID 参数 - 适应哈希路由
      // 假设应用使用哈希路由模式：/#/path/to/page
      url = window.location.origin + '/#/' + address + '/' + id1 + '/' + id2;
    } else {
      // 只有一个 ID 参数
      url = window.location.origin + '/#/' + address + '/' + id1;
    }
    
    console.log('生成的URL:', url);
    // 始终在新窗口中打开
    window.open(url, '_blank');
  }
  
  const pageC = (index) => {
    setstart(index)
  }
  
  const geturl = (url) => {
    return url ? url.split(';')[0] : '';
  }

  // 点击热搜词
  const handleHotSearchClick = (term) => {
    setSearchValue(term);
    setShowHotSearch(false);
  }

  // 处理搜索框聚焦
  const handleInputFocus = () => {
    setShowHotSearch(true);
  }

  // 处理搜索框失去焦点
  const handleInputBlur = () => {
    setTimeout(() => {
      setShowHotSearch(false);
    }, 200);
  }

  // 合并相同名称的产品
  const mergedProducts = useMemo(() => {
    const productMap = new Map();
    
    // 处理Product_new产品
    info.forEach(item => {
      const productName = item?.Name || item?.name;
      if (productName && !productMap.has(productName)) {
        productMap.set(productName, {
          ...item,
          type: 'product_new',
          displayName: productName,
          imageUrl: item?.img
        });
      }
    });
    
    // 处理Pluggable_Transceiver产品
    infoOld.forEach(item => {
      const productName = item?.name || item?.Name;
      if (productName) {
        if (productMap.has(productName)) {
          // 如果已存在相同名称的产品，可以选择保留更合适的那个
          const existing = productMap.get(productName);
          // 这里可以根据需要添加合并逻辑，比如优先保留有图片的产品
          if (!existing.imageUrl && item?.image) {
            productMap.set(productName, {
              ...item,
              type: 'pluggable',
              displayName: productName,
              imageUrl: item?.image
            });
          }
        } else {
          productMap.set(productName, {
            ...item,
            type: 'pluggable',
            displayName: productName,
            imageUrl: item?.image
          });
        }
      }
    });
    
    return Array.from(productMap.values());
  }, [info, infoOld]);

  // 计算当前页显示的数据
  const getCurrentPageData = () => {
    const allData = [
      ...mergedProducts,
      ...infoNew // 这里不再覆盖 type 字段
    ];
    
    const startIndex = (start - 1) * 12;
    const endIndex = startIndex + 12;
    
    return allData.slice(startIndex, endIndex);
  }

  // 判断是否为新闻
  const isNewsItem = (item) => {
    return item?.Title && (item?.Img || item?.Preview || item?.outlink !== undefined);
  }

  // 获取产品图片URL
  const getImageUrl = (item) => {
    // 判断是否是新闻
    if (isNewsItem(item)) {
      const imagePath = geturl(item?.Img);
      return imagePath ? `${ConstValue.url}assets/${imagePath}` : '';
    } else if (item.type === 'product_new') {
      const imagePath = geturl(item?.img);
      return imagePath ? `${ConstValue.url}assets/${imagePath}` : '';
    } else if (item.type === 'pluggable') {
      const imagePath = geturl(item?.image);
      return imagePath ? `${ConstValue.url}assets/${imagePath}` : '';
    }
    return '';
  }

  // 获取产品描述
  const getDescription = (item) => {
    // 判断是否是新闻
    if (isNewsItem(item)) {
      return item?.Preview || '';
    } else if (item.type === 'product_new') {
      return item?.Application || '';
    } else if (item.type === 'pluggable') {
      return item?.description || '';
    }
    return '';
  }

  // 修复图片错误处理函数
  const handleImageError = (e) => {
    const img = e.target;
    const parent = img.parentElement;
    if (parent) {
      const placeholder = parent.querySelector('.img-placeholder');
      if (placeholder) {
        img.style.display = 'none';
        placeholder.style.display = 'flex';
      }
    }
  }

  // 处理点击事件 - 所有链接都在新窗口中打开
  const handleItemClick = (item) => {
    console.log('点击项目:', item);
    
    // 判断是否是新闻
    if (isNewsItem(item)) {
      console.log('新闻类型字段:', item.type);
      if (item?.outlink) {
        const link = item?.outlink.startsWith('http') ? item?.outlink : `./#/${item?.outlink}`;
        window.open(link, '_blank');
      } else {
        // 使用 item.type（可能是 'Event' 或 'Exhibition'）
        // 注意：这里使用 id1 作为新闻 ID，id2 作为新闻类型
        toPage('newsInfo', item.id, item.type || 'Event');
      }
    } else if (item.type === 'product_new') {
      toPage('productsInfo', item?.id);
    } else if (item.type === 'pluggable') {
      toPage('productsinfo', item?.id, item?.Advanced_category);
    }
  }

  // 渲染搜索结果项
  const renderSearchItem = (item, index) => {
    const imageUrl = getImageUrl(item);
    const description = getDescription(item);
    const displayName = item.displayName || item.Name || item.name || item.Title;
    
    return (
      <div
        key={`${item.type || 'unknown'}-${item.id}-${index}`}
        className='item'
        onClick={() => handleItemClick(item)}
      >
        <div className='img-container'>
          <div className='img-wrapper'>
            {imageUrl ? (
              <img 
                src={imageUrl} 
                alt={displayName}
                className='img'
                onError={handleImageError}
              />
            ) : (
              <div className='img-placeholder'>
                <VideoCameraAddOutlined />
              </div>
            )}
            <div className='mask'></div>
          </div>
        </div>
        <div className='info_item'>
          <span 
            className='title1' 
            dangerouslySetInnerHTML={{ 
              __html: displayName?.replace(
                RegExp(searchV, "gi"), 
                `<i class="color_c">${searchV}</i>`
              ) || '' 
            }}
          ></span>
          <span 
            className='description' 
            dangerouslySetInnerHTML={{ 
              __html: description?.replace(
                RegExp(searchV, "gi"), 
                `<b class="color_c">${searchV}</b>`
              ) || '' 
            }}
          ></span>
          <span className='readmore'>
            READ MORE<span></span>
          </span>
        </div>
      </div>
    );
  }

  const currentPageData = getCurrentPageData();
  const totalItems = mergedProducts.length + infoNew.length;

  return (
    <div className='search'>
      <div className='top'>
        <div className='title'>Search</div>
        <div className='search_box'>
          <div className='search-input-wrapper'>
            <Input 
              value={searchValue} 
              onChange={(e) => { setSearchValue(e.target.value) }} 
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
              onPressEnter={() => getInfo()}
              placeholder={"Please enter keyword search"} 
            />
            {showHotSearch && hotSearchTerms.length > 0 && (
              <div className='hot-search-tags'>
                <div className='hot-search-title'>Popular Searches</div>
                <div className='tags-container'>
                  {hotSearchTerms.map((term, index) => (
                    <div 
                      key={index}
                      className='hot-search-tag'
                      onMouseDown={(e) => {
                        e.preventDefault();
                        handleHotSearchClick(term);
                      }}
                    >
                      {term}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className='button1' onClick={() => getInfo()}>
            <div className='svg'></div>
          </div>
        </div>
      </div>
      <div className='content'>
        <div className='title'>Search result:</div>
        <div className='items'>
          {isLoading ? (
            <div className='loding_search'> 
              <LoadingOutlined /> 
            </div>
          ) : null}
          
          {currentPageData.map((item, index) => renderSearchItem(item, index))}
        </div>
        
        {totalItems > 0 && !isLoading && (
          <Pagination 
            defaultCurrent={1} 
            onChange={pageC} 
            current={start} 
            pageSize={12} 
            total={totalItems} 
            pageSizeOptions={[]} 
          />
        )}

        {totalItems === 0 && !isLoading && (
          <div className='nothing'>Nothing found, please search again...</div>
        )}
      </div>
    </div>
  )
}